import { WimFn } from '@/components/service/WimFn'
import { BenQuery } from './BenQuery'
let _firstEnter = true
let _scrolling = false
let _visibilityHiddenTimer = null as any
let _visibleTimer = null as any
let _tokenTime = 0
let _landUrl = ''
const _perView = 500
let _tokenList = [] as { timeStr: string; view: string; action: string }[]
let _actionList = [] as string[]
let _scrollLockTimer = null as any
let testViewDiv = null as null | HTMLElement
const _actionMap = { vo: '打开视频', vc: '关闭视频', vp: '视频播放', iv: '点开案例图', ts: '切回网页', th: '切出网页', lt: '跳出网页', le: '关闭网页', lb: '返回网页', ss: '开始滚动', se: '结束滚动', rd: '加载完成', of: '打开表单', ow: '打开WhatsApp', ov: '打开社媒', oh: '打开主站', sd: '下拉内容', nm: '手机菜单', pm: '电脑菜单' }
type ActionType = 'vo' | 'vc' | 'vp' | 'iv' | 'ts' | 'th' | 'lt' | 'le' | 'lb' | 'ss' | 'se' | 'rd' | 'of' | 'ow' | 'ov' | 'oh' | 'sd' | 'nm' | 'pm'
export class BenView {
  static init() {
    BenView.setAction('rd')
    _landUrl = window.location.href
    window.addEventListener('scroll', () => {
      clearTimeout(_scrollLockTimer)
      if (_scrolling === false) {
        BenView.setAction('ss')
        _scrolling = true
      }
      _scrollLockTimer = setTimeout(() => {
        BenView.setAction('se')
        _scrolling = false
      }, 200)
    })
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        _visibilityHiddenTimer = setTimeout(() => {
          BenView.setAction('th')
          WimFn.sendBeanconToReplyApi()
        }, 500)
      } else if (document.visibilityState === 'visible') {
        _visibleTimer = setTimeout(() => {
          BenView.setAction('ts')
        }, 10)
      }
    })
    window.addEventListener('pagehide', (e) => {
      //别想着打印得出来，因为都关闭了或刷新了
      console.log(22222)
      clearTimeout(_visibilityHiddenTimer)
      const actionStr = e.persisted ? 'lt' : 'le'
      BenView.setAction(actionStr)
      WimFn.sendBeanconToReplyApi()
    })
    window.addEventListener('pageshow', (e) => {
      clearTimeout(_visibleTimer)
      if (_firstEnter === true) {
        _firstEnter = false
        return
      }
      BenView.setAction('lb', { replace: true })
    })
  }

  static getLandUrl() {
    return _landUrl
  }

  //如果viewList很多的话，有可能会不止32位，有可能会没有0630
  static getToken() {
    const tokenStr = _tokenList.map((item) => item.timeStr + item.view + item.action).join('.')
    _tokenList = []
    return tokenStr
  }

  static setAction(action: ActionType, { replace = false } = {}) {
    if (replace) _actionList = []
    _actionList.push(action)
    _pushToken()
  }
}

function _decToHex(num, rsLength = 2) {
  return num.toString(16).padStart(rsLength, '0')
}

function _tokenActionList() {
  const list = [..._actionList]
  _actionList = []
  let actionStr = ''
  list.forEach((str) => {
    actionStr += str
  })
  return actionStr
}

function _pushToken() {
  const scrollTop = document.documentElement.scrollTop
  const viewStr = String(Math.floor(scrollTop / _perView) + 1)
  const view = _decToHex(viewStr, 2)
  const isAdmin = BenQuery.getCookie('user') === 'admin'
  if (isAdmin) {
    if (testViewDiv === null) {
      testViewDiv = document.createElement('div')
      testViewDiv.classList.add('c-test-view')
      document.documentElement.prepend(testViewDiv)
    }
    testViewDiv.innerHTML = viewStr
  }
  const action = _tokenActionList()
  const nowTime = Date.now()
  let timeStr = ''
  if (_tokenTime === 0) {
    _tokenTime = nowTime
    timeStr = '0000'
  } else {
    const dist = Math.floor((nowTime - _tokenTime) / 1000)
    timeStr = _decToHex(dist, 4)
  }
  _tokenList.push({ timeStr, view, action })
}
